// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"41":"d7fb97c5","167":"df68296e","242":"7c33dad7","571":"7c0f7df9"}[chunkId] + ".chunk.css";
};